// extracted by mini-css-extract-plugin
export var container = "News-module--container--fX3mn";
export var newsLink = "News-module--newsLink--Ic-9+";